import firebase from 'firebase'
import axios from 'axios'
import { influencerEarningsByUser } from "@/config/appSettings"

// Ger All Influencer Earnings
export const getAllInfluencerEarnings = async (userId, filterDate) => {
  try {
    const response = await axios.get(`${influencerEarningsByUser}/?usertoken=${firebase.auth().currentUser.uid}&user=${userId}${filterDate}`)
    return response.data
  } catch (error) {
    return error
  }
}